function App() {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1>Vantig</h1>
        <p>Plateforme de veille technologique</p>
        <p style={{ color: 'green' }}>✅ Système opérationnel</p>
      </div>
    </div>
  );
}

export default App;
